/**
 * Labstep
 *
 * @module components/Metadata/DragIcon
 * @desc Icon for draggin metadata
 */

import { ICONS } from 'labstep-web/constants/icons';
import { Icon } from 'labstep-web/core/Icon';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import { TextWithCount } from 'labstep-web/core/Text/WithCount';
import type React from 'react';
import { Icon as SemanticIcon } from 'semantic-ui-react';
import type { MetadataDragIconProps } from './types';

export const MetadataDragIcon: React.FC<MetadataDragIconProps> = ({
  metadata,
}) => (
  <TextWithCount
    header
    text={metadata.displayName}
    icon={ICONS.metadata.secondary}
    dataPrivate
    customIcon={
      !metadata.is_template ? undefined : (
        <Popup
          content="Template Field"
          size="small"
          on="hover"
          trigger={
            <SemanticIcon.Group style={{ marginRight: '5px' }}>
              <Icon name="bookmark" />
              <Icon corner="top right" name="box" />
            </SemanticIcon.Group>
          }
        />
      )
    }
  />
);
